var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMusicSquareAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65 21.75c-5.19 0-7.4-2.21-7.4-7.4v-5.7c0-5.19 2.21-7.4 7.4-7.4h5.7c5.19 0 7.4 2.21 7.4 7.4v5.7c0 .36-.01.7-.03 1.03-.02.3-.22.56-.51.66-.29.1-.6.01-.81-.21-.6-.68-1.48-1.08-2.41-1.08-1.79 0-3.25 1.46-3.25 3.25 0 .59.16 1.17.47 1.67.16.28.37.53.61.74.23.2.32.52.22.8-.1.29-.36.49-.66.51-.32.02-.66.03-1.03.03h-5.7zm-5.9-13.1v5.7c0 4.36 1.54 5.9 5.9 5.9h5.17a4.7 4.7 0 0 1-.57-2.25c0-2.62 2.13-4.75 4.75-4.75.8 0 1.57.2 2.25.56V8.65c0-4.36-1.54-5.9-5.9-5.9h-5.7c-4.36 0-5.9 1.54-5.9 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52 12.97c0-1.21.99-2.2 2.2-2.2 1.21 0 2.2.99 2.2 2.2 0 1.21-.99 2.2-2.2 2.2-1.21 0-2.2-.99-2.2-2.2zm1.5 0c0 .38.31.7.7.7.39 0 .7-.31.7-.7 0-.39-.31-.7-.7-.7-.38 0-.7.31-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42 12.97V7.14c0-.91.57-1.65 1.44-1.89l2.9-.79c.9-.25 1.47-.01 1.78.23.31.24.69.72.69 1.65V12c0 .41-.34.75-.75.75s-.75-.34-.75-.75V6.34c0-.32-.07-.44-.1-.46-.03-.02-.17-.06-.48.02l-2.89.79c-.3.08-.34.29-.34.44v5.83c0 .42-.34.76-.75.76s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83 12c0-1.21.99-2.2 2.2-2.2 1.21 0 2.2.99 2.2 2.2a2.2 2.2 0 0 1-2.2 2.2c-1.21 0-2.2-.99-2.2-2.2zm1.5.01c0 .38.31.7.7.7.39 0 .7-.31.7-.7 0-.39-.32-.7-.7-.7-.38 0-.7.31-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45 9.03a.75.75 0 0 1 .53-.92l5.31-1.45c.4-.1.81.13.92.53.11.4-.13.81-.53.92L8.37 9.56c-.07.01-.14.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.94 20.44c-.45-.72-.69-1.57-.69-2.44 0-2.62 2.13-4.75 4.75-4.75s4.75 2.13 4.75 4.75c0 .87-.24 1.72-.69 2.45-.84 1.42-2.4 2.3-4.06 2.3-1.66 0-3.22-.88-4.06-2.31zm.81-2.44c0 .59.16 1.17.47 1.67.59 1 1.63 1.58 2.78 1.58s2.19-.59 2.78-1.57c.31-.51.47-1.08.47-1.68 0-1.79-1.46-3.25-3.25-3.25s-3.25 1.46-3.25 3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.99a.749.749 0 1 1 0 1.5H16.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 19.51v-2.99c0-.41.34-.75.75-.75s.75.34.75.75v2.99a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicSquareAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-square-add.c27d97a72acdb34cf9c39fdbdd7353c3.svg";
export { ForwardRef as ReactComponent };